var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRestrictedIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 6H16C10.4772 6 6 10.4772 6 16V120C6 125.523 10.4772 130 16 130H120C125.523 130 130 125.523 130 120V16C130 10.4772 125.523 6 120 6ZM16 0C7.16344 0 0 7.16344 0 16V120C0 128.837 7.16344 136 16 136H120C128.837 136 136 128.837 136 120V16C136 7.16344 128.837 0 120 0H16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7573 48.0002L31.8787 42.1215L36.1213 37.8789L42 43.7576L47.8787 37.8789L52.1213 42.1215L46.2426 48.0002L52.1213 53.8789L47.8787 58.1215L42 52.2429L36.1213 58.1215L31.8787 53.8789L37.7573 48.0002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.7573 48.0002L83.8787 42.1215L88.1213 37.8789L94 43.7576L99.8787 37.8789L104.121 42.1215L98.2426 48.0002L104.121 53.8789L99.8787 58.1215L94 52.2429L88.1213 58.1215L83.8787 53.8789L89.7573 48.0002Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 90,
    width: 40,
    height: 6,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRestrictedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/restricted-icon.df10bc3e86d126a80294724abf4e1192.svg";